export default __webpack_public_path__ + "static/media/cwallet.e52c7593.png";